<template>
  <div>
    <Header />
    <div class="personalServicesHome">
      <!-- <Nav /> -->

      <div class="container" style="position:relative">
        <div class="pic lPic"></div>
        <div class="pic rPic"></div>
        <div class="intro">
          <div class="title">溯源优才服务平台<Guide ref="guide"/></div>
          <div class="description">
            是“全国人力资源信息数据验证平台”的唯一数据应用服务通道，平台存储的所有个人数据，均经过本人授权采集，
          </div>
          <div class="description">
            严格遵守国家相关法律法规进行管理。<span class="bold"
              >未经本人授权，任何第三方（包括溯源优才平台管理方）均无法查看。</span
            >
          </div>
        </div>
        <div class="serverList">
          <div class="serverItem" @click="handleRedirect('/personal')">
            <i class="serverIcon icon_pi"></i>
            <div>数据档案</div>
            <div class="description">
              个人自填信息、平台采集信息管理和信息勘误
            </div>
          </div>
          <div
            class="serverItem"
            @click="handleRedirect('/personal/report/list')"
          >
            <i class="serverIcon icon_pir"></i>
            <div>信息报告</div>
            <div class="description">
              生成、管理已加区块链防伪的<br />个人信息报告
            </div>
          </div>
          <div
            class="serverItem"
            @click="handleRedirect('/personal/reportCheck/list')"
          >
            <i class="serverIcon icon_rc"></i>
            <div class="new">
              查验申请处理<i v-if="redDot" class="icon_new" />
            </div>
            <div class="description">
              处理他人实名发起的<br />查验申请
            </div>
            <!-- <div class="hasNew"><i class="icon_alert"></i>有新的申请</div> -->
          </div>
          <div
            class="serverItem"
            @click="handleRedirect('/personal/checkOthers/index')"
          >
            <i class="serverIcon icon_co"></i>
            <div>查验他人</div>
            <div class="description">申请查看其它自然人、企业、<br />社会组织机构</div>
          </div>
        </div>
      </div>
      <div class="bg_bottom"></div>
      <FixedMenu/>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Nav from "@/components/Nav.vue";
import { waitDeal } from "@/api/report";
import Guide from "../../components/Guide.vue";
import FixedMenu from '../../components/FixedMenu.vue';
export default {
  components: { Header, Nav, Footer, Guide, FixedMenu },
  data() {
    return {
      redDot:
        JSON.parse(localStorage.getItem("redDot")) != undefined
          ? JSON.parse(localStorage.getItem("redDot"))
          : false
    };
  },
  created() {
    this.getRedDot();
    this.isShowGuide();
  },
  methods: {
    isShowGuide() {
      if (!JSON.parse(localStorage.getItem("showGuide"))) {
        this.handleGuideShow();
      }
    },
    getRedDot() {
      waitDeal().then(res => {
        localStorage.setItem("redDot", JSON.stringify(res.data.d));
      });
    },
    handleRedirect(path) {
      let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      if (
        userInfo.status != 3 &&
        userInfo.status != 4 &&
        path !== "/personal"
      ) {
        this.$router.push("/personal/realNameAuthentication");
      } else {
        this.$router.push(path);
      }
    },
    handleGuideShow() {
      this.$nextTick(() => {
        this.$refs.guide.handleShow();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.personalServicesHome {
  background-color: #c9d4eb;
  .pic {
    background-size: cover !important;
    position: absolute;
  }
  .lPic {
    width: 127px;
    height: 260px;
    background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/lPic.png");
    bottom: -92px;
    left: -145.5px;
  }
  .rPic {
    width: 200px;
    height: 188px;
    background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/rPic.png");
    right: -100px;
    top: 125px;
  }
  .intro {
    padding: 112px 0 50px 15px;
    &::before {
      content: "";
      width: 40px;
      height: 6px;
      background: #455a85;
      position: absolute;
      top: 94px;
    }
    .title {
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #455a85;
      line-height: 32px;
    }
    .description {
      font-size: 16px;
      color: #455a85;
      line-height: 32px;
      .bold {
        font-weight: bold;
      }
    }
  }

  .serverList {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0px 0 134px 0;
    .serverItem {
      position: relative;
      width: 245.9px;
      height: 249px;
      margin-right: 47px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      color: #3a61b1;
      font-size: 20px;
      font-weight: bold;
      background: #fff;
      border-radius: 8px;
      cursor: pointer;
      &:last-child {
        margin-right: 0;
      }
      &:hover {
        box-shadow: 0 0 10px 0 rgba(58, 97, 177, 0.52);
      }
      .serverIcon {
        width: 72.8px;
        height: 66px;
        display: inline-block;
        background-size: cover !important;
        margin-bottom: 28px;
      }
      .icon_pi {
        background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_pi.png") no-repeat;
      }
      .icon_pir {
        background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_pir.png") no-repeat;
      }
      .icon_rc {
        background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_rc.png") no-repeat;
      }
      .icon_co {
        background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_co.png") no-repeat;
      }
      .icon_alert {
        background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_alert.png") no-repeat;
        background-size: cover;
        width: 12px;
        height: 15px;
        display: inline-block;
        margin-right: 6px;
        vertical-align: middle;
      }
      .hasNew {
        font-size: 16px;
        color: #6e6e6e;
        margin-top: 16px;
        position: absolute;
        bottom: 34px;
        margin-right: 7px;
      }
      .description {
        text-align: center;
        color: #6e6e6e;
        font-size: 14px;
        margin-top: 18px;
        line-height: 25px;
        padding: 0 15px;
      }
    }
  }
  .bg_bottom {
    height: 92px;
    background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/bg_bottom.png") no-repeat;
    background-size: cover;
  }
}
.new {
  position: relative;
  .icon_new {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: inline-block;
    background: #ff3817;
    border: 2px solid #fff;
    position: absolute;
    right: -7px;
    top: -1px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personalServicesHome/index.vue